import axios from 'axios'

import {
  API_CHECK_AUTH_URL,
  API_TOKEN_REFRESH,
  API_VALVE_ISSUES,
} from '../../service/api.endpoint'


const api = axios.create({
  baseURL: API_VALVE_ISSUES,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

let refreshing: Promise<string> | null = null

async function refreshToken() {
  const refresh = localStorage.getItem('refreshToken')
  if (!refresh) throw new Error('Refresh token is missing')

  const response = await axios.post(API_TOKEN_REFRESH, {refresh})
  const {access, refresh: nextRefresh} = response.data
  localStorage.setItem('accessToken', access)
  if (nextRefresh) localStorage.setItem('refreshToken', nextRefresh)

  const userResponse = await axios.get(API_CHECK_AUTH_URL, {
    headers: {Authorization: `Bearer ${access}`},
  })
  localStorage.setItem('company', userResponse.data.data.last_name)
  localStorage.setItem('username', userResponse.data.data.username)
  return access
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config
    if (error.response?.status !== 401 || original?._retry) {
      return Promise.reject(error)
    }
    original._retry = true

    if (!refreshing) {
      refreshing = refreshToken().finally(() => {
        refreshing = null
      })
    }
    try {
      const token = await refreshing
      original.headers.Authorization = `Bearer ${token}`
      return api(original)
    } catch (refreshError) {
      localStorage.setItem('accessToken', '')
      localStorage.setItem('refreshToken', '')
      return Promise.reject(refreshError)
    }
  },
)

export default api
